export const REQUEST_DELETE_PASSENGERS = 'REQUEST_DELETE_PASSENGERS'

export default (passengerIds: string[], flightId: string) => ({
  type: REQUEST_DELETE_PASSENGERS,
  passengerIds,
  flightId,
})
